module.exports = __webpack_public_path__ + "scripts/brand-icons.eot?8e49b728";


//////////////////
// WEBPACK FOOTER
// ./semantic/dist/themes/default/assets/fonts/brand-icons.eot
// module id = 92
// module chunks = 1